import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';
import querystring from 'query-string';

export default function userUpdate(params) {
    const { baseUrl, brandId, country, user, uberToken, clientId, options } = params;

    invariant(baseUrl, 'baseUrl is a required param of userUpdate()');
    invariant(brandId, 'brandId is a required param of userUpdate()');
    invariant(country, 'country is a required param of userUpdate()');
    invariant(user, 'user is a required param of userUpdate()');
    invariant(clientId, 'clientId is a required param of userUpdate()');

    const headers = { 'Content-Type': 'application/json' };
    const queries = options ? `?${querystring.stringify(options)}` : '';
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self${queries}`;

    const body = JSON.stringify(user);

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'PUT', body }), uberToken, clientId), 'userUpdate');
}
